import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Home, FolderUp, PenLine, CreditCard, LogOut, ShieldCheck, BookOpen } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";

const NAV = [
  { to: "/portal", label: "My Progress", icon: Home, end: true },
  { to: "/portal/onboarding", label: "Intake Form", icon: PenLine },
  { to: "/portal/documents", label: "My Documents", icon: FolderUp },
  { to: "/portal/sign", label: "Agreement", icon: PenLine },
  { to: "/portal/billing", label: "Billing", icon: CreditCard },
  { to: "/portal/guides", label: "Help & Guides", icon: BookOpen },
];

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [brand, setBrand] = useState({ company_name: "CredVantage Pro" });

  useEffect(() => {
    api.get("/portal/branding").then((r) => setBrand(r.data)).catch(() => {});
  }, []);

  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[#F8FAF8]">
      <header className="bg-[#0B2545] text-white sticky top-0 z-30 shadow-md">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {brand.logo_url
              ? <img src={brand.logo_url} alt="logo" className="h-8 w-8 rounded object-cover" />
              : <ShieldCheck className="h-7 w-7 text-sky-300" />}
            <span className="font-heading font-bold text-lg" data-testid="portal-brand-name">{brand.company_name}</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-sky-200 hidden sm:block">{user?.name}</span>
            <button onClick={doLogout} data-testid="portal-logout-btn"
              className="flex items-center gap-1.5 text-sm text-sky-200 hover:text-white transition-colors duration-150">
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </div>
        <nav className="max-w-5xl mx-auto px-4 flex gap-1 overflow-x-auto pb-0">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`portal-nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2.5 text-sm font-medium rounded-t-md whitespace-nowrap transition-colors duration-150 ${
                  isActive ? "bg-[#F8FAF8] text-[#0B2545]" : "text-sky-200 hover:text-white hover:bg-white/10"
                }`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8">
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
